import builder from '../builder';
import TripPins from '../../streamline-icons/light/trip-pins.svg';

export default builder('IconTripPinsLight', TripPins);
